import { Field, TextInput, NumberInput, SectionHeader } from "./Field";
import { Wallet, FileText } from "lucide-react";

export default function StepEmployment({ form, update }) {
  return (
    <div>
      <SectionHeader
        eyebrow="Chapter III"
        title="Employment & income."
        description="A brief note on how you sustain your residence."
      />

      <div className="space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <Field label="Occupation" required testid="field-occupation">
            <TextInput
              value={form.occupation}
              onChange={(v) => update({ occupation: v })}
              placeholder="Software Engineer"
              testid="input-occupation"
            />
          </Field>
          <Field label="Current Job Title" required testid="field-job-title">
            <TextInput
              value={form.job_title}
              onChange={(v) => update({ job_title: v })}
              placeholder="Senior Engineer"
              testid="input-job-title"
            />
          </Field>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <Field label="Supervisor's Name" required testid="field-supervisor-name">
            <TextInput
              value={form.supervisor_name}
              onChange={(v) => update({ supervisor_name: v })}
              placeholder="Alex Morgan"
              testid="input-supervisor-name"
            />
          </Field>
          <Field label="Supervisor's Phone" required testid="field-supervisor-phone">
            <TextInput
              type="tel"
              value={form.supervisor_phone}
              onChange={(v) => update({ supervisor_phone: v })}
              placeholder="(555) 123-4567"
              testid="input-supervisor-phone"
            />
          </Field>
        </div>

        {/* Income requirement notice */}
        <div
          className="rounded-sm border border-[#A67C2E]/40 bg-[#A67C2E]/[0.06] p-5"
          data-testid="income-requirement-notice"
        >
          <div className="flex items-start gap-3">
            <Wallet className="w-4 h-4 text-[#A67C2E] shrink-0 mt-0.5" />
            <div>
              <p className="label-eyebrow text-[#A67C2E] mb-2">Income Requirement</p>
              <p className="text-sm text-[#4A423B] leading-relaxed">
                Combined monthly household income must be at least{" "}
                <strong>2.5&times; the monthly rent</strong>. A significant, verifiable source of income must be presentable upon request.
              </p>
            </div>
          </div>
        </div>

        <Field
          label="Monthly Income (USD)"
          hint="Gross monthly income before taxes"
          required
          testid="field-monthly-income"
        >
          <NumberInput
            value={form.monthly_income}
            onChange={(v) => update({ monthly_income: v })}
            placeholder="6000"
            min={0}
            step="100"
            testid="input-monthly-income"
          />
        </Field>

        {/* Paystub upload notice */}
        <div
          className="rounded-sm border border-[#DDD1BC] bg-white p-5"
          data-testid="paystub-notice"
        >
          <div className="flex items-start gap-3">
            <FileText className="w-4 h-4 text-[#A67C2E] shrink-0 mt-0.5" />
            <div>
              <p className="label-eyebrow text-[#A67C2E] mb-2">Verification Documents</p>
              <p className="text-sm text-[#4A423B] leading-relaxed">
                Please have <strong>2 months of income</strong> available.
                <br className="hidden sm:block" />
                <span className="text-[#6B6560]">
                  Ex. 2 months of pay stubs, bank statements, or other verifiable income, upon request.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
